import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { AlertTriangle, TrendingDown, HeartCrack } from 'lucide-react';
export function PainSection() {
  return <section className="py-24 bg-[#0a0e1a] relative overflow-hidden" data-id="element-177">
      {/* Subtle red glow for agitation */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-96 h-96 bg-red-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-178"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-179">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-180">
          <div className="order-2 lg:order-1 space-y-8" data-id="element-181">
            <FadeIn data-id="element-182">
              <div className="flex items-start gap-4" data-id="element-183">
                <div className="mt-1 bg-red-500/10 p-3 rounded-lg border border-red-500/20" data-id="element-184">
                  <TrendingDown className="w-6 h-6 text-red-400" data-id="element-185" />
                </div>
                <div data-id="element-186">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-187">
                    Modo "Supervivencia"
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-188">
                    Vivir en Argentina hoy es como correr una maratón en un
                    campo minado. La inflación, la incertidumbre y el ritmo de
                    las noticias nos tienen en alerta permanente.
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={100} data-id="element-189">
              <div className="flex items-start gap-4" data-id="element-190">
                <div className="mt-1 bg-amber-500/10 p-3 rounded-lg border border-amber-500/20" data-id="element-191">
                  <AlertTriangle className="w-6 h-6 text-amber-400" data-id="element-192" />
                </div>
                <div data-id="element-193">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-194">
                    Cortisol al Máximo
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-195">
                    Tu cuerpo está inundado de cortisol. Por eso las apps de
                    meditación con voces gallegas no te funcionan:{' '}
                    <strong className="text-slate-200" data-id="element-196">
                      porque tu realidad no es zen.
                    </strong>
                  </p>
                </div>
              </div>
            </FadeIn>

            <FadeIn delay={200} data-id="element-197">
              <div className="flex items-start gap-4" data-id="element-198">
                <div className="mt-1 bg-orange-500/10 p-3 rounded-lg border border-orange-500/20" data-id="element-199">
                  <HeartCrack className="w-6 h-6 text-orange-400" data-id="element-200" />
                </div>
                <div data-id="element-201">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-202">
                    El Costo Real
                  </h3>
                  <p className="text-slate-400 leading-relaxed" data-id="element-203">
                    Si seguís así, el cansancio crónico va a romper algo: tu
                    paciencia con tus hijos, tu rendimiento en el laburo o,
                    peor, tu salud física.
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>

          <div className="order-1 lg:order-2" data-id="element-204">
            <FadeIn direction="left" data-id="element-205">
              <div className="bg-slate-800/50 p-8 md:p-10 rounded-3xl border border-slate-700 relative" data-id="element-206">
                <div className="absolute -top-5 -left-5 text-6xl opacity-20" data-id="element-207">
                  ⚠️
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight" data-id="element-208">
                  El agotamiento{' '}
                  <span className="text-red-400 line-through decoration-white/50" data-id="element-209">
                    no se cura con café
                  </span>
                </h2>
                <p className="text-xl text-slate-300 mb-8" data-id="element-210">
                  Se cura reseteando biológicamente tu sistema nervioso.
                </p>
                <div className="h-1 w-full bg-gradient-to-r from-red-500/50 via-amber-500/50 to-transparent rounded-full" data-id="element-211"></div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}